/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
    VenueDto,
    VenueDtoFromJSON,
    VenueDtoFromJSONTyped,
    VenueDtoToJSON,
} from './';

/**
 * The response with a list of objects of type "T".
 * @export
 * @interface VenueDtoResponseListViewModel
 */
export interface VenueDtoResponseListViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof VenueDtoResponseListViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * Gets or sets the list of objects.
     * @type {Array<VenueDto>}
     * @memberof VenueDtoResponseListViewModel
     */
    data?: Array<VenueDto> | null;
}

export function VenueDtoResponseListViewModelFromJSON(json: any): VenueDtoResponseListViewModel {
    return VenueDtoResponseListViewModelFromJSONTyped(json, false);
}

export function VenueDtoResponseListViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): VenueDtoResponseListViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(VenueDtoFromJSON)),
    };
}

export function VenueDtoResponseListViewModelToJSON(value?: VenueDtoResponseListViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(VenueDtoToJSON)),
    };
}


